import { render, staticRenderFns } from "./C_ShowPage.vue?vue&type=template&id=4ebf607a&scoped=true&"
import script from "./C_ShowPage.vue?vue&type=script&lang=js&"
export * from "./C_ShowPage.vue?vue&type=script&lang=js&"
import style0 from "./C_ShowPage.vue?vue&type=style&index=0&id=4ebf607a&scoped=true&lang=css&"
import style1 from "./C_ShowPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf607a",
  null
  
)

component.options.__file = "C_ShowPage.vue"
export default component.exports